import { Box, Typography } from "@mui/material";
import styled from "styled-components";

export const SettingsIconWrapper = styled(Box)`
  width: 24px;
  height: 24px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SettingsLabel = styled(Typography)`
  color: ${(props) => props.theme.text.primary};
  font-size: 16px;
  font-family: "NotoSans-Medium";
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

export const RightChevronWrapper = styled(Box)`
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SettingsRowContainer = styled.a`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
`;

export const SettingsRowContent = styled(Box)`
  display: flex;
  align-items: center;
`;

export const SubLabel = styled.span`
  font-size: 14px;
  font-family: "NotoSans-Medium";
  font-weight: 400;
  color: #898a8d;
  margin-right: 8px;
`;
